import React, {useEffect} from 'react';
import Background from "../../assets/Ocean-bg.png";
import {MainStyle} from "../../styles/pages/main/MainStyle";
import {Typography} from "@mui/material";

export const AboutOcean = () => {
	const classes = MainStyle();
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<article>
					<section>
						<Typography variant={"h4"}>
							<b>Cos'è Ocean?</b>
						</Typography>
						<Typography variant={"subtitle1"} color={"textSecondary"}>
							Ocean è la piattaforma creata e sviluppata dai programmator dell'ASL Città di Torino per la gestione dei
							pazienti durante l'emergenza Covid.<br/>
							L'applicativo è poi pensato per fare molto di più che la sola gestione pzienti, infatti è predisposto a
							venir utilizzato per una gestione dei pazienti anche al di fuori dell'emergenza, gestendo un monitoraggio
							a distanza dei singoli pazienti e permettendo ad ogni paziente di potersi interfacciare con gli operatori
							dell'ASL in modo diretto.
						</Typography>
					</section>
				</article>
			</main>
		</React.Fragment>
	);
}